import { render, staticRenderFns } from "./TourEdit.vue?vue&type=template&id=37e51025&scoped=true&"
import script from "./TourEdit.vue?vue&type=script&lang=js&"
export * from "./TourEdit.vue?vue&type=script&lang=js&"
import style0 from "./TourEdit.vue?vue&type=style&index=0&id=37e51025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e51025",
  null
  
)

export default component.exports